import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AnchorIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Anchor",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.28 16.6c-1.37.65-2.68 1.42-3.92 2.29-.11.15.28.55.83.98-1.63 1.98-3.78 4.66-6.76 5.63-.05-1.21-.46-7.48-.76-12.05h3.07c.35.46.89.73 1.46.72a1.9 1.9 0 0 0 1.75-2.03c-.07-.93-.81-1.68-1.75-1.75-.57 0-1.11.27-1.46.72h-3.23c0-.45-.06-.87-.09-1.23a4.13 4.13 0 0 0 2.04-5.48 4.13 4.13 0 0 0-5.48-2.04 4.13 4.13 0 0 0-2.04 5.48c.45.99 1.28 1.77 2.3 2.15v1.08h-3.19a1.88 1.88 0 0 0-1.49-.68 1.9 1.9 0 0 0-1.75 2.03c.07.93.81 1.68 1.75 1.75.57 0 1.12-.26 1.46-.72h3.07c-.22 4.64-.58 10.5-.66 11.91-2.06-.73-4.31-2.37-6.86-5.3.69-.51 1.21-.99 1.08-1.17-1.24-.88-2.55-1.64-3.92-2.29-.37-.17-.64 0-.59.83.04 1.37.18 2.74.43 4.09.09.17.65 0 1.34-.41 8.11 11.6 13.49 12.14 21.9-.14.79.44 1.5.73 1.59.55.25-1.35.39-2.72.43-4.09.11-.87-.19-.96-.56-.83ZM15.72 7.99c-1.08 0-1.94-.88-1.94-1.96s.88-1.94 1.96-1.94c1.07 0 1.94.88 1.94 1.95a1.964 1.964 0 0 1-1.96 1.93z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.29 9c-2.52 0-4.57-2.05-4.57-4.57s2.05-4.57 4.57-4.57 4.57 2.05 4.57 4.57S18.81 9 16.29 9m0-6.86C15.03 2.14 14 3.17 14 4.43s1.03 2.29 2.29 2.29 2.29-1.03 2.29-2.29-1.03-2.29-2.29-2.29M16.29 31.86c-6.3 0-11.43-5.13-11.43-11.43a1.14 1.14 0 1 1 2.28 0c0 5.04 4.1 9.14 9.14 9.14s9.14-4.1 9.14-9.14a1.14 1.14 0 1 1 2.28 0c0 6.3-5.13 11.43-11.43 11.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.29 31.86c-.63 0-1.14-.51-1.14-1.14V7.86a1.14 1.14 0 1 1 2.28 0v22.86c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22 14.71H10.57a1.14 1.14 0 1 1 0-2.28H22a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
AnchorIcon.displayName = 'AnchorIcon';